import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type StartMoveAssetsOperationMutationVariables = Types.Exact<{
  input: Types.StartMoveAssetsOperationInput;
}>;


export type StartMoveAssetsOperationMutation = { __typename?: 'Mutation', startMoveAssetsOperation?: { __typename?: 'StartMoveAssetsOperationPayload', assetOperation?: { __typename?: 'CopyAssetsOperation', id?: string | null } | { __typename?: 'DeleteAssetsOperation', id?: string | null } | { __typename?: 'HardDeleteAssetsOperation', id?: string | null } | { __typename?: 'MoveAssetsOperation', id?: string | null } | { __typename?: 'UpdateAssetFieldValuesOperation', id?: string | null } | null } | null };


export const StartMoveAssetsOperation = /*#__PURE__*/ gql`
    mutation StartMoveAssetsOperation($input: StartMoveAssetsOperationInput!) {
  startMoveAssetsOperation(input: $input) {
    assetOperation {
      id
    }
  }
}
    ` as unknown as DocumentNode<StartMoveAssetsOperationMutation, StartMoveAssetsOperationMutationVariables>;

          

          export const useStartMoveAssetsOperationMutation = (options?:MutationHookOptions<StartMoveAssetsOperationMutation, StartMoveAssetsOperationMutationVariables>) => useMutation(StartMoveAssetsOperation, options);
          

          export type StartMoveAssetsOperationMutationOptions = MutationHookOptions<StartMoveAssetsOperationMutation, StartMoveAssetsOperationMutationVariables>;

          

          export type StartMoveAssetsOperationMutationResult = ReturnType<typeof useStartMoveAssetsOperationMutation>[1];

          
